import { ChakraProvider } from "@chakra-ui/react";
import { ApolloProvider } from "@apollo/client";
import { noCacheClient } from "./helpers/apolloClient";
import { ConfirmationProvider } from "./contexts/ConfirmationContext";
import { AuthProvider } from "./contexts/AuthContext";
import { AppRoutes } from "./AppRoutes";
import { Provider } from "react-redux";
import store from "./redux/store";
import theme from "./theme/theme";
import GlobalStyles from "./theme/GlobalStyles";
import "@fontsource/inter/600.css";
import "@fontsource/inter/500.css";
import { Font } from "@react-pdf/renderer";
import 'react-datepicker/dist/react-datepicker.css'

Font.register({
  family: "Poppins",
  fonts: [
    {
      src: "/fonts/Poppins-Regular.ttf",
    },
    {
      src: "/fonts/Poppins-SemiBold.ttf",
      fontWeight: 600,
    },
    {
      src: "/fonts/Poppins-SemiBoldItalic.ttf",
      fontWeight: 600,
      fontStyle: "italic",
    },
  ],
});

function App() {
  return (
    <Provider store={store}>
      <ApolloProvider client={noCacheClient}>
        <ChakraProvider theme={theme}>
          <GlobalStyles />
          <ConfirmationProvider>
            <AuthProvider>
              <AppRoutes />
            </AuthProvider>
          </ConfirmationProvider>
        </ChakraProvider>
      </ApolloProvider>
    </Provider>
  );
}

export default App;
